import {
  notification_colorAlert,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_size_sm,
  font_size_xs,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};
  padding: ${spacing(5)};

  .NotificationItem-topRow {
    display: flex;
    flex-direction: row;
    gap: ${spacing(3)};
    justify-content: space-between;

    .NotificationItem-topRow-title {
      overflow: hidden;
      text-overflow: ellipsis;
      flex-grow: 1;
      color: ${text_colorTextPrimary};
      font-family: ${font_family_weight_medium};
      font-size: ${font_size_sm};
      line-height: 16px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }

    .NotificationItem-topRow-timestamp {
      text-align: right;
      color: ${text_colorTextSecondary};
      font-family: ${font_family_weight_regular};
      font-size: ${font_size_xs};
      line-height: 125%;
      min-width: fit-content;
    }
  }

  .NotificationItem-bottomRow {
    display: flex;
    flex-direction: row;
    gap: ${spacing(2)};
    justify-content: space-between;
    align-items: center;

    .NotificationItem-bottomRow-body {
      overflow: hidden;
      text-overflow: ellipsis;
      flex-grow: 1;
      color: ${text_colorTextSecondary};
      font-family: ${font_family_weight_regular};
      font-size: ${font_size_sm};
      line-height: 16px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }

    .NotificationItem-bottomRow-unreadDot {
      min-width: ${spacing(2)};
      height: ${spacing(2)};
      background-color: ${notification_colorAlert};
      border-radius: 50%;
      display: none;

      &.unread {
        display: initial;
      }
    }
  }
`
